import { call, put, take, select, fork, cancel, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import api from '../api/api'
import { appendToFormData } from '../helpers/utility'
import questionSchema from '../schemas/question'
import testSchema from '../schemas/test'
import ticketOrdersSchema from '../schemas/ticketOrders'
import onlineTestSchema from '../schemas/onlineTest'
import { normalize } from 'normalizr'
import { isResponseSuccessful, statusCodeIsBelow400 } from '../helpers/utility'

import {
  CREATE_QUESTION_REQUEST,
  CREATE_QUESTION_SUCCESS,
  CREATE_QUESTION_FAIL,
  CREATE_QUESTION_ASYNC_START,
  CREATE_QUESTION_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_QUESTIONS_LIST_REQUEST,
  FETCH_QUESTIONS_LIST_SUCCESS,
  FETCH_QUESTIONS_LIST_FAIL,
  FETCH_QUESTIONS_LIST_ASYNC_END,
  FETCH_QUESTIONS_LIST_ASYNC_START,
} from '../actions/actions'

import {
  CREATE_TEST_REQUEST,
  CREATE_TEST_SUCCESS,
  CREATE_TEST_FAIL,
  CREATE_TEST_ASYNC_START,
  CREATE_TEST_ASYNC_END,
} from '../actions/actions'

import {
  ADD_TOPICS_TO_TEST_REQUEST,
  ADD_TOPICS_TO_TEST_SUCCESS,
  ADD_TOPICS_TO_TEST_FAIL,
  ADD_TOPICS_TO_TEST_ASYNC_END,
  ADD_TOPICS_TO_TEST_ASYNC_START,
} from '../actions/actions'

import {
  ADD_QUESTIONS_TO_TEST_REQUEST,
  ADD_QUESTIONS_TO_TEST_SUCCESS,
  ADD_QUESTIONS_TO_TEST_FAIL,
  ADD_QUESTIONS_TO_TEST_ASYNC_END,
  ADD_QUESTIONS_TO_TEST_ASYNC_START,
} from '../actions/actions'

import {
  FETCH_ONLINE_TESTS_ASYNC_END,
  FETCH_ONLINE_TESTS_ASYNC_START,
  FETCH_ONLINE_TESTS_SUCCESS,
  FETCH_ONLINE_TESTS_FAIL,
  FETCH_ONLINE_TESTS_REQUEST,
} from '../actions/actions'

import {
  FETCH_SINGLE_TEST_REQUEST,
  FETCH_SINGLE_TEST_SUCCESS,
  FETCH_SINGLE_TEST_FAIL,
  // FETCH_SINGLE_TEST_ASYNC_END,
  // FETCH_SINGLE_TEST_ASYNC_START
} from '../actions/actions'

import {
  CREATE_ONLINE_TEST_TICKET_ORDER_REQUEST,
  CREATE_ONLINE_TEST_TICKET_ORDER_SUCCESS,
  CREATE_ONLINE_TEST_TICKET_ORDER_FAIL,
  CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_END,
  CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_START,
} from '../actions/actions'

import {
  FETCH_USER_TEST_TICKET_ORDERS_REQUEST,
  FETCH_USER_TEST_TICKET_ORDERS_SUCCESS,
  FETCH_USER_TEST_TICKET_ORDERS_FAIL,
  FETCH_USER_TEST_TICKET_ORDERS_ASYNC_START,
  FETCH_USER_TEST_TICKET_ORDERS_ASYNC_END,
} from '../actions/actions'

import {
  TAKE_THE_TEST_REQUEST,
  TAKE_THE_TEST_SUCCESS,
  TAKE_THE_TEST_FAIL,
  TAKE_THE_TEST_ASYNC_START,
  TAKE_THE_TEST_ASYNC_END,
} from '../actions/actions'

import {
  CHECK_TEST_STATUS_REQUEST,
  CHECK_TEST_STATUS_SUCCESS,
  CHECK_TEST_STATUS_FAIL,
  CHECK_TEST_STATUS_ASYNC_START,
  CHECK_TEST_STATUS_ASYNC_END,
} from '../actions/actions'

import {
  TEST_STARTED,
  LEFT_THE_TEST,
  SUBMIT_ANSWERS_SUCCESS,
  SUBMIT_ANSWERS_FAIL,
  SUBMIT_ANSWERS_ASYNC_START,
  SUBMIT_ANSWERS_ASYNC_END,
} from '../actions/actions'

import {
  SUBMIT_STASH_IMMEDIATELY_REQUEST,
  // SUBMIT_STASH_IMMEDIATELY_SUCCESS,
  // SUBMIT_STASH_IMMEDIATELY_FAIL,
  SUBMIT_STASH_IMMEDIATELY_ASYNC_START,
  // SUBMIT_STASH_IMMEDIATELY_ASYNC_END
} from '../actions/actions'

import {
  FETCH_TEST_RESULT_REQUEST,
  FETCH_TEST_RESULT_SUCCESS,
  // FETCH_TEST_RESULT_FAIL,
  FETCH_TEST_RESULT_ASYNC_START,
  FETCH_TEST_RESULT_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_REQUEST,
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_SUCCESS,
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_FAIL,
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_START,
  FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END,
} from '../actions/actions'

import {
  UNSUBMIT_QUESTION_FROM_TEST_REQUEST,
  UNSUBMIT_QUESTION_FROM_TEST_SUCCESS,
  UNSUBMIT_QUESTION_FROM_TEST_FAIL,
  UNSUBMIT_QUESTION_FROM_TEST_ASYNC_START,
  UNSUBMIT_QUESTION_FROM_TEST_ASYNC_END,
} from '../actions/actions'

export function* createQuestion() {
  while (true) {
    const { resolve, reject, formData } = yield take(CREATE_QUESTION_REQUEST)
    yield put({ type: CREATE_QUESTION_ASYNC_START })

    try {
      const {
        data: { status, errors },
      } = yield call(api.createQuestion, formData)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: CREATE_QUESTION_SUCCESS,
        })

        resolve()
      } else {
        yield put({ type: CREATE_QUESTION_FAIL, errors })
        reject(errors)
      }

      yield put({ type: CREATE_QUESTION_ASYNC_END })
    } catch (error) {
      yield put({ type: CREATE_QUESTION_ASYNC_END })
      yield put({ type: CREATE_QUESTION_FAIL, error })
    }
  }
}

export function* watchFetchListOfQuestions() {
  yield takeEvery(FETCH_QUESTIONS_LIST_REQUEST, fetchListOfQuestions)
}

function* fetchListOfQuestions({ queryString, resolve, reject }) {
  yield put({ type: FETCH_QUESTIONS_LIST_ASYNC_START })

  try {
    const {
      data: { data, status, errors },
    } = yield call(api.fetchListOfQuestions, queryString)

    if (statusCodeIsBelow400(status)) {
      const normalizedResponse = normalize(data.questions, questionSchema)

      yield put({
        type: FETCH_QUESTIONS_LIST_SUCCESS,
        questions: normalizedResponse,
        count: data.count,
      })

      resolve && resolve(normalizedResponse)
    } else {
      yield put({ type: FETCH_QUESTIONS_LIST_FAIL, errors })
      reject && reject()
    }

    yield put({ type: FETCH_QUESTIONS_LIST_ASYNC_END })
  } catch (error) {
    yield put({ type: FETCH_QUESTIONS_LIST_ASYNC_END })
    yield put({ type: FETCH_QUESTIONS_LIST_FAIL, error })
  }
}

export function* fetchListOfQuestionsForEventMaker() {
  while (true) {
    const { queryString, topicId } = yield take(
      FETCH_QUESTION_LIST_FOR_EVENT_MAKER_REQUEST
    )

    yield put({ type: FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.fetchListOfQuestions, queryString)

      if (statusCodeIsBelow400(status)) {
        const normalizedResponse = normalize(data.questions, questionSchema)

        yield put({
          type: FETCH_QUESTION_LIST_FOR_EVENT_MAKER_SUCCESS,
          questions: normalizedResponse,
          count: data.count,
          topicId,
        })
      } else {
        yield put({ type: FETCH_QUESTION_LIST_FOR_EVENT_MAKER_FAIL, errors })
      }

      yield put({ type: FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END })
      yield put({ type: FETCH_QUESTION_LIST_FOR_EVENT_MAKER_FAIL, error })
    }
  }
}

export function* createOnlineTest() {
  while (true) {
    const { formData, resolve, reject } = yield take(CREATE_TEST_REQUEST)
    yield put({ type: CREATE_TEST_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.createOnlineTest, formData)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: CREATE_TEST_SUCCESS,
          test: data.quiz,
        })

        resolve(data.quiz)
      } else {
        yield put({ type: CREATE_TEST_FAIL, errors })
        reject(errors)
      }

      yield put({ type: CREATE_TEST_ASYNC_END })
    } catch (error) {
      yield put({ type: CREATE_TEST_ASYNC_END })
      yield put({ type: CREATE_TEST_FAIL, error })
    }
  }
}

export function* addTopicsToTest() {
  while (true) {
    const { formData, testId, resolve, reject } = yield take(ADD_TOPICS_TO_TEST_REQUEST)
    yield put({ type: ADD_TOPICS_TO_TEST_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.addTopicsToTest, formData, testId)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: ADD_TOPICS_TO_TEST_SUCCESS,
          test: data.quiz.event_quizzes,
        })

        resolve(data.quiz.event_quizzes)
      } else {
        yield put({ type: ADD_TOPICS_TO_TEST_FAIL, errors })
        reject(errors)
      }

      yield put({ type: ADD_TOPICS_TO_TEST_ASYNC_END })
    } catch (error) {
      yield put({ type: ADD_TOPICS_TO_TEST_ASYNC_END })
      yield put({ type: ADD_TOPICS_TO_TEST_FAIL, error })
    }
  }
}

export function* addQuestionsToTest() {
  while (true) {
    const { formData, testId, resolve, reject } = yield take(
      ADD_QUESTIONS_TO_TEST_REQUEST
    )

    yield put({ type: ADD_QUESTIONS_TO_TEST_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.addQuestionsToTest, formData, testId)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        const successfullySubmittedQuestions = data.quiz.quiz_questions.map(
          question => question.question
        )

        yield put({
          type: ADD_QUESTIONS_TO_TEST_SUCCESS,
          questions: successfullySubmittedQuestions,
        })

        resolve(successfullySubmittedQuestions)
      } else {
        yield put({ type: ADD_QUESTIONS_TO_TEST_FAIL, errors })
        reject(errors)
      }

      yield put({ type: ADD_QUESTIONS_TO_TEST_ASYNC_END })
    } catch (error) {
      yield put({ type: ADD_QUESTIONS_TO_TEST_ASYNC_END })
      yield put({ type: ADD_QUESTIONS_TO_TEST_FAIL, error })
    }
  }
}

export function* fetchTestsList() {
  while (true) {
    const { queryString } = yield take(FETCH_ONLINE_TESTS_REQUEST)
    yield put({ type: FETCH_ONLINE_TESTS_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.fetchListOfTests, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_ONLINE_TESTS_SUCCESS,
          tests: normalize(data.quizs, testSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_ONLINE_TESTS_FAIL, errors })
      }

      yield put({ type: FETCH_ONLINE_TESTS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_ONLINE_TESTS_ASYNC_END })
      yield put({ type: FETCH_ONLINE_TESTS_FAIL, error })
    }
  }
}

export function* fetchSingleTest() {
  while (true) {
    const { testId } = yield take(FETCH_SINGLE_TEST_REQUEST)
    yield put({ type: FETCH_ONLINE_TESTS_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.fetchSingleTest, testId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SINGLE_TEST_SUCCESS,
          test: data.quiz,
        })
      } else {
        yield put({ type: FETCH_SINGLE_TEST_FAIL, errors })
      }

      yield put({ type: FETCH_ONLINE_TESTS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_ONLINE_TESTS_ASYNC_END })
      yield put({ type: FETCH_SINGLE_TEST_FAIL, error })
    }
  }
}

export function* createTestTicketOrder() {
  while (true) {
    const { formData, resolve, reject } = yield take(CREATE_ONLINE_TEST_TICKET_ORDER_REQUEST)
    yield put({ type: CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.createTestTicketOrder, formData)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: CREATE_ONLINE_TEST_TICKET_ORDER_SUCCESS,
          ticket_order: data.ticket_order,
        })

        resolve(data)
      } else {
        yield put({ type: CREATE_ONLINE_TEST_TICKET_ORDER_FAIL, errors })
        reject(errors)
      }

      yield put({ type: CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_END })
    } catch (error) {
      yield put({ type: CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_END })
      yield put({ type: CREATE_ONLINE_TEST_TICKET_ORDER_FAIL, error })
    }
  }
}

export function* fetchUserTestTicketOrders() {
  while (true) {
    yield take(FETCH_USER_TEST_TICKET_ORDERS_REQUEST)
    yield put({ type: FETCH_USER_TEST_TICKET_ORDERS_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.fetchUserTestTicketOrders)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_USER_TEST_TICKET_ORDERS_SUCCESS,
          ticket_orders: normalize(data.ticket_orders, ticketOrdersSchema),
        })
      } else {
        yield put({ type: FETCH_USER_TEST_TICKET_ORDERS_FAIL, errors })
      }

      yield put({ type: FETCH_USER_TEST_TICKET_ORDERS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_USER_TEST_TICKET_ORDERS_ASYNC_END })
      yield put({ type: FETCH_USER_TEST_TICKET_ORDERS_FAIL, error })
    }
  }
}

export function* checkStatusOfTest() {
  while (true) {
    const { testId, reject, resolve } = yield take(CHECK_TEST_STATUS_REQUEST)
    yield put({ type: CHECK_TEST_STATUS_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.checkStatusOfTest, testId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: CHECK_TEST_STATUS_SUCCESS,
          status: data.status,
        })

        resolve(data.status)
      } else {
        yield put({ type: CHECK_TEST_STATUS_FAIL, errors })
        reject(errors)
      }

      yield put({ type: CHECK_TEST_STATUS_ASYNC_END })
    } catch (error) {
      yield put({ type: CHECK_TEST_STATUS_ASYNC_END })
      yield put({ type: CHECK_TEST_STATUS_FAIL, error })
    }
  }
}

export function* takeTheTest() {
  while (true) {
    const { testId, reject, resolve } = yield take(TAKE_THE_TEST_REQUEST)
    yield put({ type: TAKE_THE_TEST_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.takeTheTest, testId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: TAKE_THE_TEST_SUCCESS,
          test: {
            ...normalize(data.quiz, onlineTestSchema),
            remainingTimeInSeconds: data.remaining_time,
          },
        })

        resolve && resolve(data.quiz)
      } else {
        yield put({ type: TAKE_THE_TEST_FAIL, errors })
        reject && reject(errors)
      }

      yield put({ type: TAKE_THE_TEST_ASYNC_END })
    } catch (error) {
      yield put({ type: TAKE_THE_TEST_ASYNC_END })
      yield put({ type: TAKE_THE_TEST_FAIL, error })
    }
  }
}

export function* startTest() {
  while (yield take(TEST_STARTED)) {
    // starts the task in the background
    const bgSyncTask = yield fork(submitStashedAnswersPeriodically)

    // wait for the user stop action
    yield take(LEFT_THE_TEST)
    // user clicked stop. cancel the background task
    // this will cause the forked bgSync task to jump into its finally block
    yield cancel(bgSyncTask)
  }
}

const formatAnswers = (test, answers) => {
  const testId = Object.keys(test)[0]

  const formattedAnswers = Object.keys(answers).map(questionId => ({
    question: parseInt(questionId, 10),
    option: parseInt(answers[questionId], 10),
  }))

  const result = {
    testId,
    formData: appendToFormData({
      quiz: parseInt(testId, 10),
      answered_questions: JSON.stringify(formattedAnswers),
    }),
  }

  return result
}

function* submitStashedAnswersPeriodically() {
  while (true) {
    yield delay(1000 * 60 * 5) // wait 5 mins before submitting
    const answers = yield select(state => state.answersStash.answers)

    if (Object.keys(answers).length > 0) {
      // skip if no answer is found
      const test = yield select(state => state.testToTake.entities.test)
      const formattedAnswers = formatAnswers(test, answers)
      yield call(submitAnswers, formattedAnswers.formData, formattedAnswers.testId)
    } else {
      yield put({ type: 'SUBMIT_SKIPPED' })
    }
  }
}

export function* submitStashedAnswersImmediately() {
  while (true) {
    const { closed, resolve, reject } = yield take(SUBMIT_STASH_IMMEDIATELY_REQUEST)
    const answers = yield select(state => state.answersStash.answers)

    if (Object.keys(answers).length > 0) {
      yield put({ type: SUBMIT_STASH_IMMEDIATELY_ASYNC_START })
      const test = yield select(state => state.testToTake.entities.test)
      const formattedAnswers = formatAnswers(test, answers)

      if (closed) {
        formattedAnswers.formData.append('closed', true)
      }

      yield call(submitAnswers, formattedAnswers.formData, formattedAnswers.testId, {
        resolve,
        reject,
      })
    } else {
      yield put({ type: 'IMMEDIATE_SUBMIT_SKIPPED' })
      resolve && resolve() // stash is already empty -> skip submitting
    }
  }
}

const storeSubmittedAnswers = (submittedAnswers, testId) => {
  let prevSubmittedAnswers = JSON.parse(localStorage.getItem(`test-${testId}`)) // its an object

  for (let answer of submittedAnswers) {
    prevSubmittedAnswers[answer.question] = answer.option
  }

  localStorage.setItem(`test-${testId}`, JSON.stringify(prevSubmittedAnswers))
}

function* submitAnswers(answers, testId, promise) {
  yield put({ type: SUBMIT_ANSWERS_ASYNC_START, answers })

  try {
    const {
      data: { data, status, errors },
    } = yield call(api.submitTestAnswers, answers)

    if (statusCodeIsBelow400(status)) {
      yield put({ type: SUBMIT_ANSWERS_SUCCESS, data })
      promise && promise.resolve()
      storeSubmittedAnswers(data.submit.answered_questions, testId)
    } else {
      yield put({ type: SUBMIT_ANSWERS_FAIL, errors })
      promise && promise.reject(errors)
    }

    yield put({ type: SUBMIT_ANSWERS_ASYNC_END })
  } catch (err) {
    yield put({ type: SUBMIT_ANSWERS_FAIL, err })
    yield put({ type: SUBMIT_ANSWERS_ASYNC_END })
  }
}

export function* fetchResultOfTest() {
  while (true) {
    const { testId } = yield take(FETCH_TEST_RESULT_REQUEST)
    yield put({ type: FETCH_TEST_RESULT_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.getTestResult, testId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_TEST_RESULT_SUCCESS,
          result: data.result,
        })
      } else {
        yield put({ type: CHECK_TEST_STATUS_FAIL, errors })
      }

      yield put({ type: FETCH_TEST_RESULT_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_TEST_RESULT_ASYNC_END })
      yield put({ type: CHECK_TEST_STATUS_FAIL, error })
    }
  }
}

export function* removeQuestionFromTest() {
  while (true) {
    const { questionId, testId, topicId } = yield take(
      UNSUBMIT_QUESTION_FROM_TEST_REQUEST
    )
    yield put({ type: UNSUBMIT_QUESTION_FROM_TEST_ASYNC_START })

    try {
      const {
        data: { status, errors },
      } = yield call(api.removeQuestionFormTest, questionId, testId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: UNSUBMIT_QUESTION_FROM_TEST_SUCCESS,
          questionId,
          topicId,
        })
      } else {
        yield put({ type: UNSUBMIT_QUESTION_FROM_TEST_FAIL, errors })
      }

      yield put({ type: UNSUBMIT_QUESTION_FROM_TEST_ASYNC_END })
    } catch (error) {
      yield put({ type: UNSUBMIT_QUESTION_FROM_TEST_ASYNC_END })
      yield put({ type: UNSUBMIT_QUESTION_FROM_TEST_FAIL, error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/onlineTestSaga.js